export default __webpack_public_path__ + "static/media/osmosis-scientist-front-compressed.62610e4d.png";